import * as React from 'react';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import founderPng from "../static/founder.png";
import Stack from '@mui/material/Stack';

export default function BlogPublishInfo({date}) {
    return (
      <Stack direction="row-reverse" sx={{
        mx: {sm: 7, xs: 7},
        my: {sm: 2, xs: 3},
      }}>
        <Avatar 
          alt="Shubham Chodankar"
          src={founderPng}
          sx={{
            width: 50,
            height: 50,
            mx: {sm: 1, xs: 1}
          }}
        />
        <Typography variant="subtitle1">
          Shubham Chodankar
          <Typography variant="subtitle2">
            Senior Software Engineer
        </Typography>
          <Typography variant="subtitle2">
              5 minutes read. {date}
          </Typography>
        </Typography>
      </Stack>
    );
  }